"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var render_bridge_1 = require("../render-bridge");
var moduleOption = {
    default: { RenderBridge: render_bridge_1.ReactRenderer },
    toolbar: {
        menuDirection: 'down-start',
        menuDistance: 4,
        tools: [],
        icons: {},
        tooltips: {},
        showNames: {},
        RenderBridge: render_bridge_1.ReactRenderer
    },
    toolbarInline: {
        menuDirection: 'up',
        menuDistance: 18,
        tipDirection: 'up',
        tipDistance: 18,
        tools: [],
        RenderBridge: render_bridge_1.ReactRenderer
    }
};
exports.moduleOption = moduleOption;
//# sourceMappingURL=utils.js.map